import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-campus-news-events-create",
  templateUrl: "./campus-news-events-create.component.html",
  styleUrls: ["./campus-news-events-create.component.scss"],
})
export class CampusNewsEventsCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http.get<any>(this.api_endpoint + "/campus-news-events-by-id/" + `${id}`).subscribe(
        (data) => {
          if (data.data != null) {
            this.action = "Update";
            this.Form.patchValue({
              _id: data.data._id,
              type: data.data.type,
              heading: data.data.heading,
              url: data.data.url,
              image: data.data.image,
              date: data.data.date,
              description: data.data.description,
            });
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    });

    this.Form = this.formBuilder.group({
      type: ["", Validators.required],
      heading: ["", Validators.required],
      url: ["", Validators.required],
      image: ["", Validators.required],
      date: [""],
      description: [""],
      _id: [""],
    });
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    const formData = {
      type: this.Form.value.type,
      heading: this.Form.value.heading,
      url: this.Form.value.url,
      image: this.Form.value.image,
      date: this.Form.value.date,
      description: this.Form.value.description,
      _id: this.Form.value._id,
    };

    if (this.action == "Submit") {
      delete formData._id;
      this.http.post<any>(this.api_endpoint + "/campus-news-events", formData).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/campus-news-events/list-campus-news-events");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    } else {
      this.http.put<any>(this.api_endpoint + "/campus-news-events/", formData).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/campus-news-events/list-campus-news-events");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
